/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import { MainContainer } from "../../AdminList.styled";
import { DivBackgroundOpacity } from "@utils/extra-style";
import {
  countryflagIcons as flagIcons,
  defaultCountryFlag,
} from "@utils/country-data";

const Country = (props) => {
  const { t, data } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={data.status ? "1" : "0.2"}>
        <MainContainer>
          {data?.countryInfo?.map((info, infoIndex) => {
            return (
              <Image
                key={"admin_country" + infoIndex + "=" + info.country.id}
                src={
                  flagIcons[info.country.id]
                    ? flagIcons[info.country.id]
                    : defaultCountryFlag
                }
                alt="Avatar"
                title={t(info.country.name)}
                styles={{ width: "40px", marginRight: "5px" }}
              />
            );
          })}
        </MainContainer>
      </DivBackgroundOpacity>
    </>
  );
};

Country.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

Country.defaultProps = {
  page: null,
};

export default withTranslation()(Country);
